import _ from "lodash";
import { Order, PromoCode, Shop } from "../../types";
import growl from "./growl";
import moment from "moment";
import ShopService from './shop-service'
import OrderCalc from "../checkout/order-calc-service";
import Vue from 'vue'
import CartService from '../services/cart-service'

let factory = {
    displayPromoMessage,
    usablePromoCodes,
    promoDescription,
    setPromoCode,
    validateCode,
    REDUCTION_PERCENTAGE: 'PERCENTAGE',
    REDUCTION_AMOUNT: 'AMOUNT',
    getSharedUrl,
};

function getSharedUrl(promo_code: PromoCode) {
    function getBasePath() {
        let a = document.createElement("a");
        a.href = "";
        return a.href;
    }
    let ShopId = ShopService.shop.ShopId;
    return getBasePath() + ShopId + '/accueil?Promo=' + promo_code.Code;
}

function setPromoCode(promo_code: PromoCode, order: Order) {
    console.log('set promo code')
    Vue.set(order,'promo_code', promo_code);
    order.DiscountName = promoDescription(promo_code);
    OrderCalc.recalcFees(order);
}
function promoDescription(promo_code: PromoCode) {
    let isPercentageType = (promoCode) => promoCode.ReductionType == factory.REDUCTION_PERCENTAGE;

    return (
        promo_code &&
        promo_code.Code +
            " Remise de " +
            promo_code.ReductionValue +
            (isPercentageType(promo_code) ? "%" : ShopService.shop.Currency)
    );
}

function displayPromoMessage(shop: Shop) {
    console.log('dsiaply promo message')
    for(let promo_code of shop.promo_codes) {
        if (validateCode(promo_code).status == 'OK' && promo_code.ValidUntil && promo_code.Message) {
            growl.info(promo_code.Message);
            return true;
        }
    }
    return false;
}
// if order is null, checks promo conditions not depending on order (ShopId, expiry, ...)
function usablePromoCodes(order: Order = null) {
    let shop = order ? order.shop : ShopService.shop;
    return _.filter(shop.promo_codes,(promo_code)=>validateCode(promo_code, order).status == 'OK')
}

function validateCode(promo_code: PromoCode, order: Order = null): { status: 'KO'|'OK', msg?: string } {
    let errMsg = (msg: string): { status: 'KO', msg: string } => ({ status: 'KO', msg });
    if (order) {
        // additional checks for matching Order
        if (!promo_code.AllowAnonymousUse) {
            if (!order.ClientId || order.ClientId == order.shop.AnonClientId) {
                return errMsg('Connectez-vous pour bénéficier du code');
            }
        }
        if (!_.find(promo_code.sale_area_ids?.length && promo_code.sale_area_ids,(n)=> n == order.SaleAreaId)) {
            return errMsg("Le code n'est pas disponible en mode " + CartService.SALE_AREA_NAMES[order.SaleAreaId]);
            // return errMsg("Le code est disponible en mode " + promo_code.sale_area_ids.map(n=>CartService.SALE_AREA_NAMES[n]).join(', '));
        }
        if (promo_code.shop_ids?.length && !_.find(promo_code.shop_ids,(n)=> n == order.ShopId)) {
            return errMsg("Le code n'est pas disponible pour cet établissement");
        }
        if (order.Subtotal < promo_code.MinimumAmount) {
            return errMsg("Le code est valable pour un montant minimum de " + promo_code.MinimumAmount + order.Currency)
        }
    } else {
        // checks for matching shop
        let shop = ShopService.shop;
        if (shop && promo_code.shop_ids?.length && !_.find(promo_code.shop_ids,(n)=> n == shop.ShopId)) {
            return errMsg("Le code n'est pas disponible pour cet établissement");
        }
    }
    if (promo_code.RemainingUses == 0) {
        return errMsg("Le code n'est plus disponible")
    }
    let now = moment().startOf('day');
    if (promo_code.ValidFrom && now.isBefore(moment(promo_code.ValidFrom))) {
        return errMsg("Le code n'est pas encore disponible");
    }
    if (promo_code.ValidUntil && now.isAfter(promo_code.ValidUntil)) {
        return errMsg("Le code est périmé")
    }
    return { status:'OK' };
}

export default factory;